export const ROUTING_MODELS_RESET_STATE = 'GATEWAYS_RESET_STATE';
export const ROUTING_MODELS_CURRENT_ITEM = 'GATEWAYS_CURRENT_ITEM';

export const ROUTING_MODELS_REQUEST_LOADING = 'GATEWAYS_REQUEST_LOADING';
export const ROUTING_MODELS_REQUEST_SUCCESS = 'GATEWAYS_REQUEST_SUCCESS';
export const ROUTING_MODELS_REQUEST_FAILED = 'GATEWAYS_REQUEST_FAILED';

export const ROUTING_MODELS_CURRENT_ACTION = 'GATEWAYS_CURRENT_ACTION';
export const ROUTING_MODELS_RESET_ACTION = 'GATEWAYS_RESET_ACTION';